export const toastStatus = {
  TOAST_SUCCESS_TYPE: 'success',
  TOAST_WARNING_TYPE: 'warning',
  TOAST_DANGER_TYPE: 'danger',
};

export const ShowSuccessAlert = (msg) => {
  const { addToast = () => {}, extendDuration = false } = window.toast || {};
  addToast({
    message: msg,
    variant: toastStatus.TOAST_SUCCESS_TYPE,
    extendDuration,
  });
};

export const ShowDangerAlert = (msg) => {
  const { addToast = () => {}, extendDuration = false } = window.toast || {};
  addToast({
    message: msg,
    variant: toastStatus.TOAST_DANGER_TYPE,
    extendDuration,
  });
};

export const ShowWarningAlert = (msg) => {
  const { addToast = () => {}, extendDuration = false } = window.toast || {};
  addToast({
    message: msg,
    variant: toastStatus.TOAST_WARNING_TYPE,
    extendDuration,
  });
};
